import React from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import images from 'assets/images';
interface IModalProps {
    openModal: boolean;
    title?: string;
    bodyContent?: React.ReactNode;
    handleModalClose: () => void;
}

const ModalForm: React.FC<IModalProps> = ({ openModal, title, bodyContent, handleModalClose }) => {
    return (
        <Modal
            open={openModal}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="footer-modal">
                <div className="modal-header">
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {title}
                    </Typography>
                    <Button className="btn-close" onClick={handleModalClose}>
                        <img src={images.closecon} alt="Icon" />
                    </Button>
                </div>
                <div className="modal-body">{bodyContent}</div>
            </Box>
        </Modal>
    );
};

export default ModalForm;
